import { Sparkles } from 'lucide-react';
import { useLoyaltyConfig, computePointsForAmount } from '@/hooks/useLoyalty';
import { useTranslations } from '@/hooks/useTranslations';

interface PointsBadgeProps {
  amount: number;
  className?: string;
  size?: 'sm' | 'md';
}

/** Compact badge that shows how many Big-Punkte a customer would earn for an amount. */
export default function PointsBadge({ amount, className = '', size = 'sm' }: PointsBadgeProps) {
  const { settings, loading } = useLoyaltyConfig();
  const { t } = useTranslations();
  if (loading || !settings || !settings.is_enabled) return null;
  const points = computePointsForAmount(amount, settings, 1);
  if (points <= 0) return null;

  const sizeClass = size === 'md'
    ? 'text-xs px-2.5 py-1 gap-1.5'
    : 'text-[10px] px-2 py-0.5 gap-1';

  const formattedPoints = points.toLocaleString('de-CH');
  return (
    <span
      className={`inline-flex items-center rounded-full bg-primary/10 text-primary font-semibold ${sizeClass} ${className}`}
      title={t('loyalty.badge_title').replace('{points}', String(points))}
    >
      <Sparkles className={size === 'md' ? 'h-3.5 w-3.5' : 'h-2.5 w-2.5'} />
      {t('loyalty.badge_label').replace('{points}', formattedPoints)}
    </span>
  );
}
